import SquareIntegration from './SquareIntegration';
export default SquareIntegration;
